module.exports = __webpack_public_path__ + "static/media/chart-emp-green.4b9fb323.svg";